import { ofType } from "redux-observable";
import { notifyError, sendApiRequest } from "../../../actions";
import {
  getOfferIdsFulfilled,
  getOfferIdsPending,
  getOfferIdsRejected,
} from "../actions/getOfferIdsAction";
import { GET_OFFER_IDS } from "../types/getOfferIdsTypes";
import { debounceTime, mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";

const getOfferIdsPayload = (payload) => ({
  method: "get",
  url: `client/all?categoryType=Company&clientNameOrOfferId=${payload}`,
  onSuccess: [(response) => getOfferIdsFulfilled(response)],
  onError: [getOfferIdsRejected, (error) => notifyError(error)],
});

const meta = {
  api: "ajaxApi",
};

const getOfferIdsEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_OFFER_IDS.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getOfferIdsPending()),
        of(sendApiRequest(getOfferIdsPayload(payload), meta))
      )
    )
  );

export default getOfferIdsEpic$;



// WEBPACK FOOTER //
// ./src/features/score-card/epics/getOfferIdsEpic.js